"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.domain = void 0;
require("./_errorHandle");
var domain = exports.domain = "".concat(process.env.VUE_APP_HOME_BASE_API, "/api/v1");